import axios from 'axios';
const TOKEN = 'n0faQedrepaqusu2uzur1chisijuqAxe';

const PROD_API = 'https://skyway-app.com/api/';
const DEV_API = 'https://dev.skyway-app.com/api/';

// if url has 'dev' in it, use dev api
// protip, you can use `http://dev.localhost` without editing this file.
const API_URL = window.location.host.includes('dev') || window.location.host.includes('localhost') ? DEV_API : PROD_API;

export const HTTP = axios.create({
  baseURL: API_URL,
  // This is a special header and token for the portals and portalregistrations endpoints
  headers: { 'api-token': TOKEN },
  timeout: 30000,
});
